// Components==============
import Button from "components/UI/Button";
import { motion } from "framer-motion";
import React, { useContext, useState } from "react";
import { NavLink } from "react-router-dom";
import { contactTextValues } from "utilities/contactTextValues";
import { GlobalContext } from "utilities/GlobalContextWrapper";
import { useMediaQ } from "utilities/useMediaQ";
import { useOpenUrlModal } from "utilities/useOpenUrlModal";
import Modal from "./components/Modal";
import Video from "./components/Video";
import "./index.module.scss";
// =========================

const ConditionalLink = ({ link, children }) => {
    if (link?.includes("http")) {
        return (
            <a href={link} target="_blank" rel="noreferrer">
                {children}
            </a>
        );
    }

    if (link) {
        return <NavLink to={`/${link}`}>{children}</NavLink>;
    }

    return children;
};

export default function Card({
    row,
    column,
    width,
    title,
    description,
    image,
    popupImage,
    popupContent,
    page,
    video,
    videoType,
    link,
    buttonText,
    buttonBackground = "#FFFFFF",
    buttonColor,
    background,
}) {
    const [modalIsOpen, setModalIsOpen] = useState(false);

    const { setContactText } = useContext(GlobalContext);

    const openContactModal = useOpenUrlModal("contact-popup");

    const largeScreen = useMediaQ("min", 1325);
    const tablet = useMediaQ("min", 768);

    function handleClick() {
        if (video) return;
        if (buttonText?.toLowerCase() === "neem contact op") {
            setContactText(contactTextValues.contact);
            openContactModal();
        }
        if (popupContent.length) return setModalIsOpen(true);
    }

    const gridStyle = largeScreen
        ? {
              gridRow: row || "initial",
              gridColumn: column ? `${column} / ${column + width}` : "initial",
              height: 230,
          }
        : tablet
          ? {
                height: 350,
            }
          : {
                height: 250,
            };
    return (
        <>
            <motion.div
                onClick={handleClick}
                whileHover={{ scale: 1.025 }}
                whileTap={{ scale: 0.975 }}
                styleName="wrapper"
                style={{
                    ...gridStyle,
                    backgroundImage: `url(${image})`,
                    backgroundColor: !image && background,
                    padding: video ? 0 : "",
                }}
            >
                {video ? (
                    <Video video={video} videoType={videoType} />
                ) : (
                    <ConditionalLink link={link} page={page}>
                        {image && <div styleName="overlay" />}
                        <div styleName="flex">
                            <div>
                                <h2>{title}</h2>
                                <p>{description}</p>
                            </div>
                            <Button
                                background={buttonBackground}
                                color={buttonColor}
                                style={{
                                    width: "100%",
                                    maxWidth: "max-content",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    textAlign: "left",
                                }}
                            >
                                {buttonText}
                            </Button>
                        </div>
                    </ConditionalLink>
                )}
            </motion.div>
            {modalIsOpen && (
                <Modal
                    modalIsOpen={modalIsOpen}
                    setModalIsOpen={setModalIsOpen}
                    title={title}
                    description={description}
                    image={popupImage}
                    richText={popupContent}
                />
            )}
        </>
    );
}
